import React, { lazy, ReactElement, Suspense } from 'react'

import PuxMediaSelector from '../mediaImage/PuxMediaSelector'
import { MediaSelectorImageType } from '../mediaImage/PuxPicture'

const EasySoftwareLottieClient = lazy(
  () => import(`./EasySoftwareLottieClient`)
)

export type EasySoftwareLottieProps = {
  animationData: string
  animationDataMobile?: string | null
  lottieImage?: MediaSelectorImageType | null
  externalPlaySignal?: boolean
  inViewport?: boolean
}

const getPlaceholder = ({
  animationDataMobile,
  inViewport = false,
  lottieImage,
}: EasySoftwareLottieProps): ReactElement | null =>
  lottieImage && !animationDataMobile ? (
    <div className='lottie-placeholder'>
      <PuxMediaSelector
        mediaSelectorImage={lottieImage}
        width={500}
        height={200}
        disableLazyload={inViewport}
      />
    </div>
  ) : null

function EasySoftwareLottie(props: EasySoftwareLottieProps): ReactElement {
  const placeholder = getPlaceholder(props)

  if (typeof window === `undefined`) {
    return <>{placeholder}</>
  }

  return (
    <Suspense fallback={placeholder}>
      <EasySoftwareLottieClient {...props} placeholder={placeholder} />
    </Suspense>
  )
}

export default EasySoftwareLottie
